export const END_CALL_LIST = 'END_CALL_LIST';
export function endCallList() {
  return { type: END_CALL_LIST };
}

export const SWITCH_TAB = 'SWITCH_TAB';
export function switchTab(tab) {
  return { tab, type: SWITCH_TAB };
}

export const TOGGLE_ALERT = 'TOGGLE_ALERT';
export function toggleAlert(message, error) {
  return { message, error, type: TOGGLE_ALERT };
}

export const TOGGLE_MOBILE_FILTERS = 'TOGGLE_MOBILE_FILTERS';
export function toggleMobileFilters() {
  return { type: TOGGLE_MOBILE_FILTERS };
}

export const UPDATE_CALL_DATA = 'UPDATE_CALL_DATA';
export function updateCallData(callId, callListId) {
  return { callId, callListId, type: UPDATE_CALL_DATA };
}

export const UPDATE_PREVIEW_DATA = 'UPDATE_PREVIEW_DATA';
export function updatePreviewData(contactId, contactType, taskId = null) {
  return { contactId, contactType, taskId, type: UPDATE_PREVIEW_DATA };
}

export const SHOW_OVERLAY_FILTERS = 'SHOW_OVERLAY_FILTERS';
export function showOverlayFilters() {
  return ({ type: SHOW_OVERLAY_FILTERS });
}

export const HIDE_OVERLAY_FILTERS = 'HIDE_OVERLAY_FILTERS';
export function hideOverlayFilters() {
  return ({ type: HIDE_OVERLAY_FILTERS });
}
